'use client';

import { useCallback, useEffect, useState } from 'react';
import { MoonIcon } from 'lucide-react';
import { useTheme } from 'next-themes';

import { IconSunLow } from '@tabler/icons-react';

import { Button } from './ui/Button';
import { KeyboardShortcutToken } from './keyboard-shortcut-token';
let theme: string | undefined;

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isLightTheme = resolvedTheme === 'light';
  const [mounted, setMounted] = useState(false);

  const onToggle = useCallback(() => {
    setTheme(isLightTheme ? 'dark' : 'light');
    theme = isLightTheme ? 'dark' : 'light';
  }, [isLightTheme, setTheme]);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (resolvedTheme === 'system') {
      setTheme('light');
    }
  }, [resolvedTheme, setTheme]);
  return (
    <Button variant="secondary" size="xs" onClick={onToggle} className="flex gap-2">
      <div className="flex items-center justify-center">
        {!mounted || isLightTheme ? (
          <MoonIcon className=" h-4 w-4 rotate-[270deg] transform" />
        ) : (
          <IconSunLow className="h-4 w-4" />
        )}
        <span className="sr-only">Toggle theme</span>
      </div>
      <span>{!mounted || isLightTheme ? 'Dark' : 'Light'} Theme</span>
      <KeyboardShortcutToken keys="m" onShortcut={onToggle} />
    </Button>
  );
}
